import axios, { AxiosInstance } from 'axios';
import { apiRRHHURL, mockAndDevelopment } from '../../app.config';

const rrhhClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiRRHHURL(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default rrhhClient;
